import React from "react";
import styled from "styled-components";
import SpinnerImg from "../assets/images/spinner.gif";

// NOTE 로딩 창
export default function Loading() {
  return (
    <Spinner>
      <SpinnerImage src={SpinnerImg} />
    </Spinner>
  );
}

// 스타일 조정
const Spinner = styled.div`
  position: absolute;
  top: calc(50% - 100px);
  left: calc(50% - 100px);
  display: flex;
  justify-content: center;
  align-items: center;

  width: 200px;
  height: 200px;
  z-index: 9;
`;

// 이미지 투명도
const SpinnerImage = styled.img`
  opacity: 0.5;
`;
